import React from "react";
import * as Gatsby from "gatsby";
import styled from "styled-components";
import * as Ant from "antd";
import * as Theme from "../Theme";
import { connect } from "react-redux";
import { withPage } from "../PageContainer";
import ApiArticle from "../ApiArticle";
import Constants from "../constants";
import ActionCreator from "../ActionCreator";
import Selectors from "../Selectors";
import * as Catalog from "../Contexts/CatalogContext";
import ArticleItem from "../Components/ArticleItem";
import Carousel from "../Components/HomeBannerCarousel";
import PromoZoneList from "../Components/PromoZoneList";
import ProductItem from "../Components/ProductItem";
import { StaticImage } from "../Components/StaticImage";
const slugify = require("uslug");

const MAX_WIDTH = 1024;
// function Category({ type, products }) {
//   return (
//     <div style={{ marginBottom: 20 }}>
//       <h2>{type}</h2>
//       {products.map(product => (
//         <Gatsby.Link key={product.name} to={`/product/${product.name}`}>
//           <div
//             style={{
//               border: "1px solid grey",
//               padding: 20,
//               backgroundColor: "white",
//               margin: 10,
//             }}
//           >
//             <h3>{product.name}</h3>
//           </div>
//         </Gatsby.Link>
//       ))}

//       {products.length === 0 && <div>No products</div>}
//     </div>
//   );
// }

const fake_banners = [
  {
    image: "../../images/banner1.jpg",
  },
];

const intro_items = [
  {
    icon: "../../images/collaboration.png",
    title: "標題",
    subtitle: "副標題",
  },
  {
    icon: "../../images/america.png",
    title: "標題",
    subtitle: "副標題",
  },
  {
    icon: "../../images/heart_with_pulse.png",
    title: "標題",
    subtitle: "副標題",
  },
  {
    icon: "../../images/literature.png",
    title: "標題",
    subtitle: "副標題",
  },
];

const social_icons = [
  {
    image: "social_ig.png",
    link: "https://www.instagram.com/li.xiang.print/",
  },
  {
    image: "social_line.png",
    link: "https://line.me/R/ti/p/%40754pymsx",
  },
  {
    image: "social_fb.png",
    link: "https://www.facebook.com/lixiangprint/",
  },
];
class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this._apiArticle = ApiArticle({ apiHost: Constants.revBlogServiceApi });
    this.state = {
      banners: fake_banners,
      products: [],
      articles: [],
    };
  }

  async componentDidMount() {
    try {
      this._fetchArticles();
      //let banners = await Catalog.Actions.fetchPromoItems("banner");
      //this.setState({ banners });
      let products = await Catalog.Actions.fetchProducts({
        category: "最新",
        sort: "",
      });
      this.setState({ products });
    } catch (ex) {
      console.warn(ex);
    }
  }

  render() {
    let { navActions } = this.props;
    const { banners, products, articles } = this.state;

    return (
      <Wrapper>
        <div className="center-content">
          <Carousel imagesArray={banners} />
          <div className={"sub-promote-banner-wrapper"}>
            <PromoZoneList type={"top_zone"} />
          </div>
          <Slogan>
            <div>突破始於好奇心</div>
            <div>
              默克是由醫療保健、生命科學與特用材料領域專家集結而成的活躍團隊。
            </div>
            <div>我們熱愛科學，並熱衷探索科技。</div>
          </Slogan>
          <div className="intro-items">
            {intro_items.map((item, idx) => (
              <ServiceItem index={idx}>
                <img src={item.icon} height="auto" width="50" />
                <div className="col">
                  <p className="title" data-delighter>
                    {item.title}
                  </p>
                  <p className="subtitle" data-delighter>
                    {item.subtitle}
                  </p>
                </div>
              </ServiceItem>
            ))}
          </div>
        </div>

        <div style={{ background: "#ececec" }}>
          <PromoZoneList type={"bottom_zone"} extraCss={"margin-top: 15px;"} />
        </div>

        <div className="center-content">
          <div className="row-section">
            <p className="title">最新商品</p>
            <div className="products-wrapper">
              {products.slice(0, 8).map((p, idx) => {
                return (
                  <ProductItem
                    key={idx}
                    product={p}
                    onClick={() => {
                      navActions.push(`/product?id=${p.id}`);
                    }}
                    extraCss={"width: calc(25% - 10px);"}
                  />
                );
              })}

              {/* compensate blank item for ui: justfy-content: space-between */}
              {[0, 1, 2].map(e => (
                <ProductItem
                  key={e}
                  product={null}
                  extraCss={"width: calc(25% - 10px);"}
                />
              ))}
            </div>
          </div>
        </div>
        <IntroWrapper>
          <p data-delighter>突破始於好奇心</p>
          <p data-delighter>
            默克是由醫療保健、生命科學與特用材料領域專家集結而成的活躍團隊。
          </p>
          <p data-delighter>我們熱愛科學，並熱衷探索科技。</p>
          <Ant.Button
            className="hover-reverse-btn"
            type="primary"
            onClick={() => navActions.push("/products")}
            style={{
              flexGrow: 0,
              border: 0,
            }}
          >
            全部課程
          </Ant.Button>
        </IntroWrapper>
        {/* <div className="center-content">
          <div className="row-section">
            <p className="title">理想聚焦</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              {articles.slice(0, 3).map(record => (
                <div key={record.id} className="article-item-wrapper">
                  <ArticleItem
                    article={record}
                    extraStyle={{
                      marginTop: 10,
                      marginBottom: 10,
                      width: "100%",
                    }}
                    type="portrait"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="row-section">
            <p className="title">社群連結</p>
            <div className="social-icons-wrapper">
              {social_icons.map((icon, idx) => (
                <a
                  className={"social-icon"}
                  key={idx}
                  href={`${icon.link}`}
                  target="_blank"
                >
                  <StaticImage key={idx} name={`${icon.image}`} />
                </a>
              ))}
            </div>
          </div>
        </div> */}
      </Wrapper>
    );
  }

  _fetchArticles = async () => {
    try {
      const resp = await this._apiArticle.findArticles({
        find: {
          project: "sensationsprint",
          label: {
            $not: {
              $regex: "FAQ",
            },
          },
        },
        sort: "-created",
      });

      this.setState({ articles: resp });
    } catch (ex) {}
  };
}

const Wrapper = styled.div`
  background-color: #fff;

  .center-content {
    max-width: ${MAX_WIDTH + 40}px;
    margin: 20px auto;
    padding: 0px 20px;

    @media screen and (max-width: 600px) {
      padding: 0;
    }

    & > .sub-promote-banner-wrapper {
      overflow: hidden;
      padding-top: 15px;
      @media screen and (max-width: 600px) {
        padding: 20px;
      }
    }

    & .row-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 25px;

      & > .title {
        text-align: center;
        font-size: 20px;
        color: #c89664;
        padding: 7px 50px;
        border-bottom: 1px solid ${Theme.colors.main};
      }

      & .social-icons-wrapper {
        display: flex;
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;

        & > .social-icon {
          width: calc(33% - 20px);
        }

        & > .social-icon:nth-child(2) {
          margin-left: 10px;
          margin-right: 10px;
        }

        @media screen and (max-width: 600px) {
          & > .social-icon {
            width: 100%;
          }
          & > .social-icon:nth-child(2) {
            margin-left: 0px;
            margin-right: 0px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }

      & .article-item-wrapper {
        width: calc(33.33% - 10px);

        @media screen and (max-width: 600px) {
          width: 100%;
          margin: 5px 0px;
        }
      }

      & > .products-wrapper {
        align-self: stretch;
        /* min-height: 640px; */
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      @media screen and (max-width: 600px) {
        padding: 0px 15px;
      }
    }
  }
  .intro-items {
    margin-top: 20px;
    /* overflow: hidden; */
    display: flex;
    flex-wrap: wrap;
  }

  & .col {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    & > .title {
      letter-spacing: 2px;
      color: #5a5a5a;
      margin-bottom: 5px;
    }

    & > .title.delighter,
    & > .subtitle.delighter {
      transition: all 0.3s ease-out;
      transform: translateX(50%);
      opacity: 0.5;
    }

    & > .title.delighter.started,
    & > .subtitle.delighter.started {
      transform: none;
      opacity: 1;
    }

    & > .subtitle {
      color: #5a5a5a;
      font-size: 10px;
    }
  }
`;

const ServiceItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-basis: 25%;
  padding: 10px 0px;
  align-items: center;

  @media screen and (max-width: 600px) {
    flex-basis: 50%;
    border-left: ${props =>
      props.index % 2 === 0 ? "none" : "1px solid #bdbdbd"};
    border-bottom: ${props => (props.index < 2 ? "1px solid #bdbdbd" : "none")};
  }

  & .col {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    flex-basis: 110px;

    & > .subtitle {
      color: #5a5a5a;
      font-size: 10px;
    }

    & p {
      margin-bottom: 0px;
    }

    & > .title {
      letter-spacing: 2px;
      color: #5a5a5a;
      margin-bottom: 5px;
    }
  }
  ${props => props.css}
`;

const IntroWrapper = styled.div`
  background-color: #eeeeef;
  height: 230px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding-left: calc((100% - ${MAX_WIDTH}px) / 2);
  padding-right: calc((100% - ${MAX_WIDTH}px) / 2);

  @media screen and (max-width: 1024px) {
    padding: 0px 20px;
  }

  & > p.delighter {
    transition: all 0.3s ease-out;
    transform: translateY(50%);
    opacity: 0.2;
  }

  & > p.delighter.started {
    transform: none;
    opacity: 1;
  }

  & > p {
    color: #9a9a9a;
    letter-spacing: 2px;
    line-height: 20px;
  }

  & .hover-reverse-btn {
    align-self: flex-end;
    background-color: ${Theme.colors.main};
    color: ${Theme.colors.textReverse};
    &:hover {
      color: ${Theme.colors.main};
      background-color: ${Theme.colors.textReverse};
    }
  }
`;

const Slogan = styled.div`
  width: 100%;
  height: 140px;
  background-image: url("/images/footer_bg.jpg");
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
  word-break: keep-all;
  padding: 20px;

  & > div {
    text-align: center;
  }

  @media screen and (max-width: 1024px) {
    padding: 0px 20px;
    font-size: 14px;
  }
`;

export default withPage(
  Catalog.withConsumer(
    connect(
      (state, ownProps) => ({
        profile: Selectors.getLoginUser(state),
      }),
      ActionCreator
    )(LandingPage)
  )
);
